import { type ReactNode, useMemo } from 'react';
import { useResponsiveDrawerColumns } from 'hooks/useResponsiveDrawerColumns';
import { chunk } from 'lodash';
import { Col, Row, type RowProps } from '@timeedit/ui-components/antd';
import './DrawerLayout.scss';

type TDrawerLayoutProps = {
  gutter?: RowProps['gutter'];
  children: ReactNode[];
  numberOfColumns?: number;
};
export const DrawerLayout = ({
  gutter = [16, 0],
  children,
  numberOfColumns,
}: TDrawerLayoutProps) => {
  const { nbrOfColumns } = useResponsiveDrawerColumns();
  const effectiveNbrOfColumns = numberOfColumns ?? nbrOfColumns;

  const chunkedFormItems = useMemo<ReactNode[][]>(() => {
    return chunk(children, Math.ceil(children.length / effectiveNbrOfColumns));
  }, [effectiveNbrOfColumns, children]);

  return (
    <Row gutter={gutter} justify="space-between">
      {chunkedFormItems.map((chunk, index) => {
        return (
          <Col
            className="drawer-layout-col"
            span={24 / effectiveNbrOfColumns}
            key={`${index}-${effectiveNbrOfColumns}-${children.length}`}
          >
            {chunk.map((item) => item)}
          </Col>
        );
      })}
    </Row>
  );
};
